module.exports = __webpack_public_path__ + "media/images/logos/dfe-b8f05cc6694575a0bd4acfbb722a6562.svg";